export function clearFromStepSearchParam(navigate, location = window.location) {
  if (typeof navigate !== 'function' || !location) {
    return false;
  }

  const params = new URLSearchParams(location.search || '');
  if (!params.has('from_step')) {
    return false;
  }

  params.delete('from_step');
  const search = params.toString();

  navigate(
    {
      pathname: location.pathname,
      search: search ? `?${search}` : '',
      hash: location.hash || '',
    },
    { replace: true }
  );

  return true;
}
